// extracted by mini-css-extract-plugin
export default {"root":"IconMessenger_root__KI+u+"};